import {defineStore} from "pinia";

export const useRoleStore = defineStore('role', {
    state: () => ({
        role: {},
        roles: [],
    }),
    actions: {
        setRole(role) {
            this.role = role
        },
        setRoles(roles) {
            this.roles = roles
        },
        addRole(role) {
            this.roles.unshift(role)
        },
        updateRole(role) {
            let index = this.roles.findIndex(cl => cl.id === role.id)
            this.roles.splice(index, 1, role)
        },
        deleteRole(role) {
            let index = this.roles.findIndex(cl => cl.id === role.id)
            this.roles.splice(index, 1)
        },
    },
});